module.exports = __webpack_public_path__ + "static/media/player_level_A.98fa6ce9.png";